const state = {
    user: {},
    userLogOffPage: null
};

const getters = {
    getUser: state => {
        return state.user;
    },

    getUserLogOffPage: state => {
        return state.userLogOffPage;
    }
};

const mutations = {
    setUser: (state, data) => {
        state.user = data;
    },

    setUserLogOffPage: (state, data) => {
        state.userLogOffPage = data;
    }
};

const actions = {
    setUser: ({commit}, data) => {
        commit('setUser', data);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}